import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MediaType } from '@epicuro-next/models/engagement';
import { ShareLinkParams } from '@epicuro-next/models/share-link';
import { map } from 'rxjs/operators';

import { SHARED_LINK_API_TOKEN } from '../../tokens';
import {
  ShareLinkPayload,
  ShareLinkRedirectBody,
  ShareLinkType,
} from '../models/share-link-payload';

@Injectable()
export class ShareLinkService {
  constructor(
    private http: HttpClient,
    @Inject(SHARED_LINK_API_TOKEN) private readonly sharedLinkApiUrl: string,
  ) {}

  public getShareLink(params: ShareLinkParams, appDomain = '') {
    const sharedLinkUrl = `${this.sharedLinkApiUrl}?tiny=${params.tiny}`;
    const payload = this.getSharedLinkPayload(params, appDomain);

    return this.http
      .post<{ link: string }>(sharedLinkUrl, payload)
      .pipe(map((result) => result.link));
  }

  private getSharedLinkPayload(params: ShareLinkParams, appDomain: string) {
    const shareLinkRedirectBody = this.getShareLinkRedirectBody(params);
    const encodedRedirectBody = btoa(JSON.stringify(shareLinkRedirectBody));
    const url = `${appDomain}/url-resolver?redirect=${encodedRedirectBody}`;

    const shareLinkPayload: ShareLinkPayload = {
      name: params.name,
      url,
    };

    const mainMedia = params?.mainMedia;
    const mediaUrl = mainMedia?.url;

    if (mainMedia?.mediaType === MediaType.Image) {
      shareLinkPayload.imageUrl = mediaUrl;
    } else {
      shareLinkPayload.videoUrl = mediaUrl;
      shareLinkPayload.imageUrl =
        mainMedia?.thumbnails?.[5] ?? mainMedia?.thumbnails?.[0];
    }

    return shareLinkPayload;
  }

  private getShareLinkRedirectBody(
    params: ShareLinkParams,
  ): ShareLinkRedirectBody {
    const type = params?.parentId
      ? ShareLinkType.LookBookProductList
      : ShareLinkType.ProductList;

    return {
      siteId: params.siteId,
      subSiteId: params?.subSiteId,
      source: 'link',
      entity: {
        type,
        id: params.id,
        parentId: params?.parentId,
      },
    };
  }
}
